<div (clickOutside)="onClickOutside()">

<app-input class="w-100"
           popperTrigger="none"
           [popper]="datepickerPopper"
           [disabled]="disabled"
           [popperPlacement]="NgxPopperjsPlacements.BOTTOM"
           [fc]="fc"
           [label]="label"
           [readonly]="true"
           (inputFocus)="onFocus()"></app-input>

<popper-content #datepickerPopper>
    <app-datepicker
      #datepicker
      [minDate]="minDate"
      [maxDate]="maxDate"
      navigation="select"
      outsideDays="hidden"
      (dateSelect)="onDateSelection($event)"></app-datepicker>
</popper-content>
</div>
